import { render } from "./videoTemplate.vue?vue&type=template&id=43f2a286&scoped=true&ts=true"
import script from "./videoTemplate.vue?vue&type=script&lang=ts"
export * from "./videoTemplate.vue?vue&type=script&lang=ts"

import "./videoTemplate.vue?vue&type=style&index=0&id=43f2a286&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-43f2a286"]])

export default __exports__